import { Typography } from '@mui/material';
import { GeoEventBaseChangelog } from 'features/geoEvents/components/GeoEventChangelog';
import { useGeoEventGeolocationFormFieldChanges } from 'features/geoEvents/hooks/useGeoEventGeolocationFormFieldChanges';
import { useNotificationTypeFormFieldChanges } from 'features/geoEvents/hooks/useNotificationTypeFormFieldChanges';
import { useComplexWildfireFormFieldChanges } from 'features/wildfires/hooks/useComplexWildfireFormFieldChanges';
import { usePrescribedWildfireFormFieldChanges } from 'features/wildfires/hooks/usePrescribedWildfireFormFieldChanges';
import { useWildfireProgressFormFieldChanges } from 'features/wildfires/hooks/useWildfireProgressFormFieldChanges';
import { GeoEventRegion } from 'features/geoEvents/geoEventRegion.types';
import { Wildfire } from 'features/wildfires/wildfire.types';
import { EvacZone, RegionEvacZoneStyle } from 'shared/types';

type WildfireChangelogProps = {
  wildfire: Wildfire;
  evacZones: EvacZone[];
  zoneStyle: RegionEvacZoneStyle;
  initialRegions?: GeoEventRegion[];
  title?: string;
  hideConfirmations?: boolean;
  notifiesRegionChanges?: boolean;
  isProvisional?: boolean;
};

export const WildfireChangelog = (
  props: WildfireChangelogProps,
): JSX.Element | null => {
  const {
    wildfire,
    evacZones,
    zoneStyle,
    initialRegions,
    title,
    hideConfirmations,
    notifiesRegionChanges,
    isProvisional,
  } = props;

  const locationChanges = useGeoEventGeolocationFormFieldChanges({
    geoEvent: wildfire,
  });
  const progressChanges = useWildfireProgressFormFieldChanges({
    wildfire,
  });
  const notificationTypeChanges = useNotificationTypeFormFieldChanges({
    geoEvent: wildfire,
  });
  const complexWildfireChanges = useComplexWildfireFormFieldChanges({
    wildfire,
  });
  const prescribedWildfireChanges = usePrescribedWildfireFormFieldChanges({
    wildfire,
  });

  return (
    <GeoEventBaseChangelog
      geoEvent={wildfire}
      evacZones={evacZones}
      zoneStyle={zoneStyle}
      initialRegions={initialRegions}
      title={title}
      hideConfirmations={hideConfirmations}
      notifiesRegionChanges={notifiesRegionChanges}
      isProvisional={isProvisional}
    >
      {Object.values(notificationTypeChanges).map((change) => (
        <Typography key={change}>{change}</Typography>
      ))}

      {Object.values(locationChanges).map((change) => (
        <Typography key={change}>{change}</Typography>
      ))}

      {Object.values(progressChanges).map((change) => (
        <Typography key={change}>{change}</Typography>
      ))}

      {Object.values(complexWildfireChanges).map((change) => (
        <Typography key={change}>{change}</Typography>
      ))}

      {Object.values(prescribedWildfireChanges).map((change) => (
        <Typography key={change}>{change}</Typography>
      ))}
    </GeoEventBaseChangelog>
  );
};
